function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, MetadataThunkHelper, ThunkHelper } from 'invision-core';
import { retrieveConvergentBillerInvoicesPromise, retrieveSusbcriberDepositsPromise } from './customer.convergent.biller.actions';
import values from 'ramda/src/values';
export var SEARCH_CASES_CONSTANTS = {
  BEGIN: 'SEARCH_CASES_BEGIN',
  SUCCESS: 'SEARCH_CASES_SUCCESS',
  FAILURE: 'SEARCH_CASES_FAILURE'
};
var SEARCH_CASES_EVENTS = [SEARCH_CASES_CONSTANTS.BEGIN, SEARCH_CASES_CONSTANTS.SUCCESS, SEARCH_CASES_CONSTANTS.FAILURE];
export var searchCases = function searchCases(customerId, additionalOpts) {
  return function (dispatch) {
    ThunkHelper(dispatch, SEARCH_CASES_EVENTS, {
      method: 'post',
      url: 'SubscriberManagement/SearchCases',
      data: additionalOpts,
      headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
    }, {
      customerId: customerId,
      pageNumber: additionalOpts.PageNumber,
      pageSize: additionalOpts.PageSize
    });
  };
};
export var RETRIEVE_CASE_CONSTANTS = {
  BEGIN: 'RETRIEVE_CASE_BEGIN',
  SUCCESS: 'RETRIEVE_CASE_SUCCESS',
  FAILURE: 'RETRIEVE_CASE_FAILURE'
};
var RETRIEVE_CASE_EVENTS = [RETRIEVE_CASE_CONSTANTS.BEGIN, RETRIEVE_CASE_CONSTANTS.SUCCESS, RETRIEVE_CASE_CONSTANTS.FAILURE];
var retrieveCasePromise = function retrieveCasePromise(dispatch, customerId, caseId) {
  return ThunkHelper(dispatch, RETRIEVE_CASE_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveCase',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {
      Id: {
        // TODO(ASC-39170): SHOULD be removed once the code type issue introducing the Number conversion is resolved
        // explicit cast to String, in case somehow it's become a Number in the tangle; MUST be a String
        Value: "".concat(caseId)
      }
    }
  });
};
export var retrieveCase = function retrieveCase(customerId, caseId) {
  return function (dispatch) {
    return retrieveCasePromise(dispatch, customerId, caseId);
  };
};
export var CREATE_CASE_CONSTANTS = {
  BEGIN: 'CREATE_CASE_BEGIN',
  SUCCESS: 'CREATE_CASE_SUCCESS',
  FAILURE: 'CREATE_CASE_FAILURE'
};
var CREATE_CASE_EVENTS = [CREATE_CASE_CONSTANTS.BEGIN, CREATE_CASE_CONSTANTS.SUCCESS, CREATE_CASE_CONSTANTS.FAILURE];
var createCasePromise = function createCasePromise(dispatch, customerId, subCase) {
  return ThunkHelper(dispatch, CREATE_CASE_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/CreateCase',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {
      Case: subCase
    }
  }, {
    customerId: customerId
  });
};
export var createCase = function createCase(customerId, subCase) {
  return function (dispatch) {
    return createCasePromise(dispatch, customerId, subCase);
  };
};
export var UPDATE_CASE_CONSTANTS = {
  BEGIN: 'UPDATE_CASE_BEGIN',
  SUCCESS: 'UPDATE_CASE_SUCCESS',
  FAILURE: 'UPDATE_CASE_FAILURE'
};
var UPDATE_CASE_EVENTS = [UPDATE_CASE_CONSTANTS.BEGIN, UPDATE_CASE_CONSTANTS.SUCCESS, UPDATE_CASE_CONSTANTS.FAILURE];
var updateCasePromise = function updateCasePromise(dispatch, customerId, case_, addedCaseActivities, addedCaseRemarks) {
  return ThunkHelper(dispatch, UPDATE_CASE_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/UpdateCase',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {
      AddedCaseActivities: addedCaseActivities,
      AddedRemarks: addedCaseRemarks,
      Case: case_
    }
  });
};
export var updateCase = function updateCase(customerId, case_, addedCaseActivities, addedCaseRemarks) {
  return function (dispatch) {
    return updateCasePromise(dispatch, customerId, case_, addedCaseActivities, addedCaseRemarks);
  };
};
export var GET_CASE_ACTIVITIES_STATUS = {
  BEGIN: 'GET_CASE_ACTIVITIES_BEGIN',
  SUCCESS: 'GET_CASE_ACTIVITIES_SUCCESS',
  FAILURE: 'GET_CASE_ACTIVITIES_FAILURE'
};
var GET_CASE_ACTIVITIES_EVENTS = [GET_CASE_ACTIVITIES_STATUS.BEGIN, GET_CASE_ACTIVITIES_STATUS.SUCCESS, GET_CASE_ACTIVITIES_STATUS.FAILURE];
var getCaseActivitiesRequest = function getCaseActivitiesRequest(dispatch, category) {
  return MetadataThunkHelper(dispatch, GET_CASE_ACTIVITIES_EVENTS, {
    method: 'get',
    url: "CaseActivities/CaseCategoryCode/".concat(category),
    headers: _defineProperty({}, ApiConstants.JSON_LONG_AS_STRING_HEADER, true)
  });
};
export var retrieveCaseActivities = function retrieveCaseActivities(category) {
  return function (dispatch) {
    return getCaseActivitiesRequest(dispatch, category);
  };
};
export var fetchInvoices = function fetchInvoices(subscriberId) {
  return function (dispatch) {
    return retrieveConvergentBillerInvoicesPromise(dispatch, subscriberId);
  };
};
export var fetchDeposits = function fetchDeposits(subscriberId) {
  return function (dispatch) {
    return retrieveSusbcriberDepositsPromise(dispatch, subscriberId);
  };
};
export var RESET_CURRENT_CASE = 'RESET_CURRENT_CASE';
export var resetCurrentCase = function resetCurrentCase() {
  return {
    type: RESET_CURRENT_CASE
  };
};
export var UPDATE_CASE_SELECTED_CATEGORY_ID = 'UPDATE_CASE_SELECTED_CATEGORY_ID';
export var updateCaseSelectedCategoryId = function updateCaseSelectedCategoryId(data) {
  return {
    type: UPDATE_CASE_SELECTED_CATEGORY_ID,
    payload: data
  };
};
export var REMOVE_CASE_SELECTED_CATEGORY_ID = 'REMOVE_CASE_SELECTED_CATEGORY_ID';
export var removeCaseSelectedCategoryId = function removeCaseSelectedCategoryId() {
  return {
    type: REMOVE_CASE_SELECTED_CATEGORY_ID
  };
};
export var UPDATE_CASE_INVENTORY_ITEM = 'UPDATE_CASE_INVENTORY_ITEM';
export var updateCaseInventoryItem = function updateCaseInventoryItem(data) {
  return {
    type: UPDATE_CASE_INVENTORY_ITEM,
    payload: data
  };
};
export var SET_CASE_STATUS_FILTER = 'SET_CASE_STATUS_FILTER';
export var setCaseStatusFilter = function setCaseStatusFilter(includeStatusFilter) {
  return {
    type: SET_CASE_STATUS_FILTER,
    payload: includeStatusFilter
  };
};
export var SET_CURRENT_PAGE = 'SET_CASES_CURRENT_PAGE';
export var setCurrentPage = function setCurrentPage(page) {
  return {
    type: SET_CURRENT_PAGE,
    payload: page
  };
};
export var EMPTY_CASES_LIST = 'EMPTY_CASES_LIST';
export var emptyCasesList = function emptyCasesList() {
  return {
    type: EMPTY_CASES_LIST
  };
};
export var REMOVE_CASES_FILTER = 'REMOVE_CASES_FILTER';
export var removeCasesFilter = function removeCasesFilter() {
  return {
    type: REMOVE_CASES_FILTER
  };
};
export var SET_CASE_EDIT_MODE = 'SET_CASE_EDIT_MODE';
export var setCaseEditMode = function setCaseEditMode(editMode) {
  return {
    type: SET_CASE_EDIT_MODE,
    payload: editMode
  };
};
export var SET_CASE_PAGE_SIZE_PREFERENCE = 'SET_CASE_PAGE_SIZE_PREFERENCE';
export var setPageSizePreference = function setPageSizePreference(pageSize) {
  return {
    type: SET_CASE_PAGE_SIZE_PREFERENCE,
    payload: pageSize
  };
};
export var RETRIEVE_CASE_TYPES = {
  BEGIN: 'RETRIEVE_CASE_TYPES_BEGIN',
  SUCCESS: 'RETRIEVE_CASE_TYPES_SUCCESS',
  FAILURE: 'RETRIEVE_CASE_TYPES_FAILURE'
};
var retrieveCaseTypesPromise = function retrieveCaseTypesPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, values(RETRIEVE_CASE_TYPES), {
    method: 'post',
    url: 'SubscriberManagement/RetrieveFilteredCaseTypes',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {}
  });
};
export var fetchCaseTypes = function fetchCaseTypes(customerId) {
  return function (dispatch) {
    return retrieveCaseTypesPromise(dispatch, customerId);
  };
};
export var RETRIEVE_PORT_IN_DETAILS = {
  BEGIN: 'RETRIEVE_PORT_IN_DETAILS_BEGIN',
  SUCCESS: 'RETRIEVE_PORT_IN_DETAILS_SUCCESS',
  FAILURE: 'RETRIEVE_PORT_IN_DETAILS_FAILURE'
};
export var retrievePortInDetails = function retrievePortInDetails(caseId) {
  return function (dispatch) {
    return ThunkHelper(dispatch, values(RETRIEVE_PORT_IN_DETAILS), {
      method: 'post',
      url: 'SubscriberManagement/RetrievePortInDetails',
      data: {
        CaseId: caseId
      }
    });
  };
};